import { SystemSettingReducerAction, SystemSettingReducerState } from './SystemSettingModel'

const initialState: SystemSettingReducerState = {
  activePvIndex: 0,
  solarModules: [],
}
const systemSettingReducer = (state: SystemSettingReducerState = initialState, action: SystemSettingReducerAction): SystemSettingReducerState => {
  switch (action.type) {
    case 'UPDATE_ACTIVEPVINDEX':
      return { ...state, activePvIndex: action.activePvIndex ?? 0 }
    case 'UPDATE_SOLAR_MODULES':
      return { ...state, solarModules: action.solarModules ?? [] }
    default:
      return state
  }
}

export default systemSettingReducer
